import React from 'react';
import { Link } from 'react-router-dom';

function ExtraOrders() {
	return (
		<div>
			<div className="d-flex align-items-center mb-2">
							<div>
								<ul className="breadcrumb">
									<li className="breadcrumb-item"><a href="#/">Home</a></li>
									<li className="breadcrumb-item"><a href="#/">Extra</a></li>
									<li className="breadcrumb-item active"></li>
								</ul>
								<h1 className="page-header mb-0">Orders</h1>
							</div>
							<div className="ms-auto">
								<a href="#/" className="btn btn-dark px-4"><i className="fa fa-plus fa-lg me-1 ms-n2 opacity-5"></i> Create Orders</a>
							</div>
						</div>
						
						<div className="mb-3 d-md-flex gap-4 fw-bold py-1">
							<div className="mt-md-0 mt-2">
								<a href="#/" className="text-decoration-none d-flex align-items-center gap-2 link-dark">
									<iconify-icon icon="solar:download-linear" className="fs-4"></iconify-icon>
									Export
								</a>
							</div>
							<div className="mt-md-0 mt-2 d-flex align-items-center gap-2 dropdown-toggle">
								<a href="#/" data-bs-toggle="dropdown" className="d-flex align-items-center gap-2 link-dark text-decoration-none">
									<iconify-icon icon="solar:settings-linear" className="fs-4"></iconify-icon>
									More Actions
									<b className="caret ms-0"></b>
								</a>
								<div className="dropdown-menu">
									<a className="dropdown-item" href="#/">Action</a>
									<a className="dropdown-item" href="#/">Another action</a>
									<a className="dropdown-item" href="#/">Something else here</a>
									<div role="separator" className="dropdown-divider"></div>
									<a className="dropdown-item" href="#/">Separated link</a>
								</div>
							</div>
						</div>
						
						<div className="card border-0 rounded-3">
							<div className="mx-3 overflow-x-scroll">
								<ul className="nav nav-tabs nav-tabs-v2 gap-3 fs-6 flex-nowrap text-nowrap w-100">
									<li className="nav-item m-0"><a href="#/" className="nav-link px-2 active d-flex align-items-center gap-2" data-bs-toggle="tab">All</a></li>
									<li className="nav-item m-0"><a href="#/" className="nav-link px-2 d-flex align-items-center gap-2" data-bs-toggle="tab">Unfulfilled</a></li>
									<li className="nav-item m-0"><a href="#/" className="nav-link px-2 d-flex align-items-center gap-2" data-bs-toggle="tab">Unpaid</a></li>
									<li className="nav-item m-0"><a href="#/" className="nav-link px-2 d-flex align-items-center gap-2" data-bs-toggle="tab">Open</a></li>
									<li className="nav-item m-0"><a href="#/" className="nav-link px-2 d-flex align-items-center gap-2" data-bs-toggle="tab">Closed</a></li>
									<li className="nav-item m-0"><a href="#/" className="nav-link px-2 d-flex align-items-center gap-2" data-bs-toggle="tab">Local delivery</a></li>
								</ul>
							</div>
							<div className="tab-content p-3">
								<div className="tab-pane fade show active">
									<div className="row gx-2 gy-2 align-items-center mb-2">
										<div className="col-xl-7">
											<div className="d-xl-flex gap-2">
												<button className="btn btn-white d-flex align-items-center gap-2 text-ellipsis mb-xl-0 mb-2">
													<iconify-icon icon="solar:list-arrow-down-linear" className="fs-4 opacity-5"></iconify-icon> 
													Most relevant
													<b className="caret ms-auto"></b>
												</button>
												<div className="flex-1 position-relative">
													<i className="fa fa-search position-absolute top-50 start-0 translate-middle-y text-muted ms-3"></i>
													<input type="text" className="form-control ps-5" placeholder="Search orders, customers, or invoice no..." />
													<a href="#/" className="btn btn-sm rounded-pill position-absolute end-0 top-0 bottom-0 d-flex align-items-center link-secondary opacity-5 fs-6"><i className="fa fa-times-circle fa-lg"></i></a>
												</div>
											</div>
										</div>
										<div className="col-xl-5">
											<div className="row gx-2 gy-2">
												<div className="col-xl-4 col-lg-3 col-sm-4 col-6">
													<select className="form-select">
														<option value="">All Status</option>
														<option>Pending</option>
														<option>Processing</option>
														<option>Completed</option>
														<option>Cancelled</option>
													</select>
												</div>
												<div className="col-xl-4 col-lg-3 col-sm-4 col-6">
													<select className="form-select">
														<option value="">All Payment</option>
														<option>Credit Card</option>
														<option>Online Banking</option>
														<option>E-Wallet</option>
														<option>Cash</option>
													</select>
												</div>
												<div className="col-xl-4 col-lg-3 col-sm-4">
													<button className="btn btn-primary w-100">Search</button>
												</div>
											</div>
										</div>
									</div>
								
									
									<div className="table-responsive mb-3">
										<table className="table table-hover table-card table-py-8px text-nowrap align-middle mb-0">
											<thead>
												<tr>
													<th></th>
													<th>Order</th>
													<th>Date</th>
													<th>Customer</th>
													<th>Total</th>
													<th>Payment status</th>
													<th>Fulfillment status</th>
													<th>Items</th>
													<th>Delivery method</th>
												</tr>
											</thead>
											<tbody>
												<tr>
													<td className="w-10px align-middle">
														<div className="form-check">
															<input type="checkbox" className="form-check-input" id="product1" />
															<label className="form-check-label" htmlFor="product1"></label>
														</div>
													</td>
													<td><Link to="/page/order-details" className="fw-bold link-dark text-decoration-none">#1950</Link></td>
													<td>Thu 26 Nov, 12:23pm</td>
													<td>Amanda Lee</td>
													<td>$398.00</td>
													<td><span className="badge bg-success bg-opacity-15 text-success px-2 py-6px rounded fs-12px d-inline-flex align-items-center gap-1"><i className="fa fa-circle fs-6px fa-fw"></i> Paid</span></td>
													<td><span className="badge bg-success bg-opacity-15 text-success px-2 py-6px rounded fs-12px d-inline-flex align-items-center gap-1"><i className="fa fa-circle fs-6px fa-fw"></i> Fulfilled</span></td>
													<td>3 items</td>
													<td>Free shipping</td>
												</tr>
												<tr>
													<td className="w-10px align-middle">
														<div className="form-check">
															<input type="checkbox" className="form-check-input" id="product2" />
															<label className="form-check-label" htmlFor="product2"></label>
														</div>
													</td>
													<td><Link to="/page/order-details" className="fw-bold link-dark text-decoration-none">#1949</Link></td>
													<td>Thu 26 Nov, 11:54am</td>
													<td>Leonard Oii</td>
													<td>$496.00</td>
													<td><span className="badge bg-success bg-opacity-15 text-success px-2 py-6px rounded fs-12px d-inline-flex align-items-center gap-1"><i className="fa fa-circle fs-6px fa-fw"></i> Paid</span></td>
													<td><span className="badge bg-success bg-opacity-15 text-success px-2 py-6px rounded fs-12px d-inline-flex align-items-center gap-1"><i className="fa fa-circle fs-6px fa-fw"></i> Fulfilled</span></td>
													<td>1 item</td>
													<td>Local pickup</td>
												</tr>
												<tr>
													<td className="w-10px align-middle">
														<div className="form-check">
															<input type="checkbox" className="form-check-input" id="product3" />
															<label className="form-check-label" htmlFor="product3"></label>
														</div>
													</td>
													<td><Link to="/page/order-details" className="fw-bold link-dark text-decoration-none">#1948</Link></td>
													<td>Thu 25 Nov, 11:54pm</td>
													<td>John Doe</td>
													<td>$195.00</td>
													<td><span className="badge bg-warning bg-opacity-15 text-warning px-2 py-6px rounded fs-12px d-inline-flex align-items-center gap-1"><i className="fa fa-circle fs-6px fa-fw"></i> Pending</span></td>
													<td><span className="badge bg-warning bg-opacity-15 text-warning px-2 py-6px rounded fs-12px d-inline-flex align-items-center gap-1"><i className="fa fa-circle fs-6px fa-fw"></i> Unfulfilled</span></td>
													<td>2 items</td>
													<td>Express</td>
												</tr>
												<tr>
													<td className="w-10px align-middle">
														<div className="form-check">
															<input type="checkbox" className="form-check-input" id="product4" />
															<label className="form-check-label" htmlFor="product4"></label>
														</div>
													</td>
													<td><Link to="/page/order-details" className="fw-bold link-dark text-decoration-none">#1947</Link></td>
													<td>Thu 25 Nov, 11:53pm</td>
													<td>Terry Ng</td>
													<td>$195.00</td>
													<td><span className="badge bg-warning bg-opacity-15 text-warning px-2 py-6px rounded fs-12px d-inline-flex align-items-center gap-1"><i className="fa fa-circle fs-6px fa-fw"></i> Pending</span></td>
													<td><span className="badge bg-warning bg-opacity-15 text-warning px-2 py-6px rounded fs-12px d-inline-flex align-items-center gap-1"><i className="fa fa-circle fs-6px fa-fw"></i> Unfulfilled</span></td>
													<td>2 items</td>
													<td>Express</td>
												</tr>
												<tr>
													<td className="w-10px align-middle">
														<div className="form-check">
															<input type="checkbox" className="form-check-input" id="product5" />
															<label className="form-check-label" htmlFor="product5"></label>
														</div>
													</td>
													<td><Link to="/page/order-details" className="fw-bold link-dark text-decoration-none">#1946</Link></td>
													<td>Thu 25 Nov, 11:52pm</td>
													<td>Terry Ng</td>
													<td>$195.00</td>
													<td><span className="badge bg-warning bg-opacity-15 text-warning px-2 py-6px rounded fs-12px d-inline-flex align-items-center gap-1"><i className="fa fa-circle fs-6px fa-fw"></i> Pending</span></td>
													<td><span className="badge bg-warning bg-opacity-15 text-warning px-2 py-6px rounded fs-12px d-inline-flex align-items-center gap-1"><i className="fa fa-circle fs-6px fa-fw"></i> Unfulfilled</span></td>
													<td>2 items</td>
													<td>Express</td>
												</tr>
												<tr>
													<td className="w-10px align-middle">
														<div className="form-check">
															<input type="checkbox" className="form-check-input" id="product6" />
															<label className="form-check-label" htmlFor="product6"></label>
														</div>
													</td>
													<td><Link to="/page/order-details" className="fw-bold link-dark text-decoration-none">#1945</Link></td>
													<td>Thu 24 Nov, 2:43pm</td>
													<td>Lelouch Wong</td>
													<td>$900.00</td>
													<td><span className="badge bg-success bg-opacity-15 text-success px-2 py-6px rounded fs-12px d-inline-flex align-items-center gap-1"><i className="fa fa-circle fs-6px fa-fw"></i> Paid</span></td>
													<td><span className="badge bg-primary bg-opacity-15 text-primary px-2 py-6px rounded fs-12px d-inline-flex align-items-center gap-1"><i className="fa fa-circle fs-6px fa-fw"></i> Ready for pickup</span></td>
													<td>2 items</td>
													<td>Local pickup</td>
												</tr>
												<tr>
													<td className="w-10px align-middle">
														<div className="form-check">
															<input type="checkbox" className="form-check-input" id="product7" />
															<label className="form-check-label" htmlFor="product7"></label>
														</div>
													</td>
													<td><Link to="/page/order-details" className="fw-bold link-dark text-decoration-none">#1944</Link></td>
													<td>Thu 23 Nov, 2:43pm</td>
													<td>Cynthia Ting</td>
													<td>$625.00</td>
													<td><span className="badge bg-success bg-opacity-15 text-success px-2 py-6px rounded fs-12px d-inline-flex align-items-center gap-1"><i className="fa fa-circle fs-6px fa-fw"></i> Paid</span></td>
													<td><span className="badge bg-primary bg-opacity-15 text-primary px-2 py-6px rounded fs-12px d-inline-flex align-items-center gap-1"><i className="fa fa-circle fs-6px fa-fw"></i> Ready for delivery</span></td>
													<td>1 item</td>
													<td>Local pickup</td>
												</tr>
												<tr>
													<td className="w-10px align-middle">
														<div className="form-check">
															<input type="checkbox" className="form-check-input" id="product8" />
															<label className="form-check-label" htmlFor="product8"></label>
														</div>
													</td>
													<td><Link to="/page/order-details" className="fw-bold link-dark text-decoration-none">#1943</Link></td>
													<td>Thu 23 Nov, 11:59am</td>
													<td>Richard Leong</td>
													<td>$195.00</td>
													<td><span className="badge bg-body text-body px-2 py-6px rounded fs-12px d-inline-flex align-items-center gap-1"><i className="fa fa-circle fs-6px fa-fw"></i> Partially refunded</span></td>
													<td><span className="badge bg-danger bg-opacity-15 text-danger px-2 py-6px rounded fs-12px d-inline-flex align-items-center gap-1"><i className="fa fa-circle fs-6px fa-fw"></i> Partially fulfilled</span></td>
													<td>2 items</td>
													<td>Express</td>
												</tr>
												<tr>
													<td className="w-10px align-middle">
														<div className="form-check">
															<input type="checkbox" className="form-check-input" id="product9" />
															<label className="form-check-label" htmlFor="product9"></label>
														</div>
													</td>
													<td><Link to="/page/order-details" className="fw-bold link-dark text-decoration-none">#1942</Link></td>
													<td>Thu 22 Nov, 8:12am</td>
													<td>Clement Tang</td>
													<td>$195.00</td>
													<td><span className="badge bg-success bg-opacity-15 text-success px-2 py-6px rounded fs-12px d-inline-flex align-items-center gap-1"><i className="fa fa-circle fs-6px fa-fw"></i> Paid</span></td>
													<td><span className="badge bg-success bg-opacity-15 text-success px-2 py-6px rounded fs-12px d-inline-flex align-items-center gap-1"><i className="fa fa-circle fs-6px fa-fw"></i> Fulfilled</span></td>
													<td>1 item</td>
													<td>Express</td>
												</tr>
												<tr>
													<td className="w-10px align-middle">
														<div className="form-check">
															<input type="checkbox" className="form-check-input" id="product10" />
															<label className="form-check-label" htmlFor="product10"></label>
														</div>
													</td>
													<td><Link to="/page/order-details" className="fw-bold link-dark text-decoration-none">#1941</Link></td>
													<td>Thu 22 Nov, 7:42am</td>
													<td>Richard Leong</td>
													<td>$195.00</td>
													<td><span className="badge bg-success bg-opacity-15 text-success px-2 py-6px rounded fs-12px d-inline-flex align-items-center gap-1"><i className="fa fa-circle fs-6px fa-fw"></i> Paid</span></td>
													<td><span className="badge bg-success bg-opacity-15 text-success px-2 py-6px rounded fs-12px d-inline-flex align-items-center gap-1"><i className="fa fa-circle fs-6px fa-fw"></i> Fulfilled</span></td>
													<td>1 item</td>
													<td>Express</td>
												</tr>
											</tbody>
										</table>
									</div>
									
									
									<div className="d-md-flex align-items-center">
										<div className="me-md-auto text-md-left text-center mb-2 mb-md-0 fw-semibold text-secondary">
											Showing 1 to 10 of 57 entries
										</div>
										<ul className="pagination mb-0 justify-content-center">
											<li className="page-item disabled"><a className="page-link" href="#/">«</a></li>
										<li className="page-item disabled"><a className="page-link" href="#/">Prev</a></li>
											<li className="page-item"><a className="page-link" href="#/">1</a></li>
											<li className="page-item active"><a className="page-link" href="#/">2</a></li>
											<li className="page-item"><a className="page-link" href="#/">3</a></li>
											<li className="page-item"><a className="page-link" href="#/">4</a></li>
											<li className="page-item"><a className="page-link" href="#/">5</a></li>
											<li className="page-item"><a className="page-link" href="#/">Next</a></li>
											<li className="page-item"><a className="page-link" href="#/">»</a></li>
										</ul>
									</div>
								</div>
							</div>
						</div>
		</div>
	);
}

export default ExtraOrders;
